import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useScrollProgress } from '../contexts/ScrollProgressContext';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ProjectItem from './ProjectItem';

// 배경 이미지
import me from '../images/imformation/me_color.jpeg'

// 점멸하는 아이콘
import tailwindcss from '../images/introduction/Tailwind.svg'
import gsapimg from '../images/introduction/GSAP.svg'
import git from '../images/introduction/git.svg'
import threejs from '../images/introduction/Threejs.svg'

// 프로젝트들
import jquery from '../images/imformation/jquery.png'

gsap.registerPlugin(ScrollTrigger);

const projects = [
  {
    src: jquery, // 이미지 변수
    alt: 'jquery',
    tag: (<>영화 기록 블로그 (HTML,CSS,jQuery)</>),
    style: 'top-[25%] left-[-5vh] w-[300px]'
  },
  {
    src: 'https://alvm1224.dothome.co.kr/kys/login.mp4', // 변경 O
    alt: 'login',
    tag: (<>블로그 사이트 (html,css,js)</>),
    style: 'top-[0%] left-[60vh] z-10 w-[400px]'
  },
  {
    src: 'https://alvm1224.dothome.co.kr/kys/mini_game_login.mp4', // 변경 O
    alt: 'mini_game_login',
    tag: (<>게임로그인화면 (html,css,js)</>),
    style: 'top-[50%] left-[40vh] w-[200px]'
  },
  {
    src: 'https://alvm1224.dothome.co.kr/kys/mini_game_broken.mp4', // 변경 O
    alt: 'mini_game_broken',
    tag: (<>벽돌깨기게임 (html,css,js)</>),
    style: 'top-[10%] left-[136vh] z-10 w-[240px]'
  },
  {
    src: 'https://alvm1224.dothome.co.kr/kys/mini_game_dino.mp4', // 변경 O
    alt: 'mini_game_dino',
    tag: (<>장애물피하기 (html,css,js)</>),
    style: 'top-[60%] left-[100vh] w-[420px]'
  },
  {
    src: 'https://alvm1224.dothome.co.kr/kys/mini_game_typing.mp4', // 변경 O
    alt: 'mini_game_typing',
    tag: (<>타이핑게임 (html,css,js)</>),
    style: 'top-[30%] left-[175vh] z-10 w-[340px]'
  },
  {
    src: 'https://alvm1224.dothome.co.kr/kys/mini_game_mypage.mp4', // 변경 O
    alt: 'mini_game_mypage',
    tag: (<>마이페이지 (html,css,js)</>),
    style: 'top-[0%] left-[235vh] w-[300px]'
  },
  {
    src: 'https://alvm1224.dothome.co.kr/kys/mini_project.mp4', // 변경 O
    alt: 'mini_project',
    tag: (<>RIZZPICK (Next.js + Typescript)</>),
    style: 'top-[60%] left-[260vh] w-[300px]'
  },
];

const carouselItems = [
  { type: 'text', content: 'EFFORT' },
  { type: 'image', src: tailwindcss, alt: 'Tailwind CSS' },
  { type: 'image', src: gsapimg, alt: 'GSAPImg' },
  { type: 'image', src: git, alt: 'GIT' },
  { type: 'image', src: threejs, alt: 'THREE.JS' },
];

const fixedRevealOrder = [
  175, 23, 179, 137, 185, 110, 169, 149, 115, 184, 186, 17, 159, 183, 192, 117, 98, 102, 33, 27,
  194, 91, 74, 96, 157, 43, 132, 195, 109, 105, 68, 14, 13, 197, 104, 82, 199, 108, 18, 113,
  128, 12, 165, 15, 164, 163, 172, 136, 19, 148, 120, 188, 103, 151, 141, 140, 135, 176, 170, 71,
  114, 55, 122, 198, 3, 173, 116, 143, 76, 124, 130, 2, 70, 48, 187, 129, 64, 89, 21, 16,
  167, 127, 47, 56, 196, 31, 86, 156, 150, 45, 160, 100, 125, 9, 39, 145, 107, 72, 5, 41,
  138, 174, 193, 28, 6, 80, 166, 88, 146, 155, 133, 90, 171, 75, 44, 153, 10, 83, 180, 50,
  58, 60, 189, 46, 52, 61, 93, 119, 121, 131, 134, 139, 142, 152, 154, 158, 161, 162, 168, 177,
  178, 181, 182, 190, 0, 1, 4, 7, 8, 11, 20, 22, 24, 25, 26, 29, 30, 32, 34, 35,
  36, 37, 38, 40, 42, 49, 51, 53, 54, 57, 59, 62, 63, 65, 66, 67, 69, 73, 77, 78,
  79, 81, 84, 85, 87, 92, 94, 95, 97, 99, 101, 106, 111, 112, 118, 126, 147, 123, 144, 191
];

const TEXT_LINES = [
  "kim yeon soo",
  "junior front-end dev",
  "1999 02 28"
];

function AnimatedBar({ scrollProgress, heightRange }) {
  // scrollProgress(0~1) 값의 변화에 따라 heightRange에 지정된 높이 값으로 변환
  const height = useTransform(
    scrollProgress,
    [0, 0.5, 0.7, 0.9, 1], // 입력값 (스크롤 진행률)
    heightRange       // 출력값 (요청하신 높이 배열)
  );

  return (
    <motion.div
      className='absolute w-full left-0 bottom-0 bg-[#eeeeee]'
      style={{
        height, // useTransform으로 생성된 motion 값을 스타일에 적용
        opacity: 1,
      }}
    />
  );
}

function Imformation() {
  const { cardScrollProgress } = useScrollProgress();
  const totalBoxes = 200;
  const boxes = Array.from({ length: totalBoxes }, (_, index) => index);
  const [revealedBoxCount, setRevealedBoxCount] = useState(0);

  useEffect(() => {
    const thirdCardProgress = cardScrollProgress[3];
    const animationStartThreshold = 0.001;
    const animationEndThreshold = 0.55;

    if (thirdCardProgress === undefined || thirdCardProgress < animationStartThreshold) {
      setRevealedBoxCount(0);
      return;
    }
    const mappedProgress = Math.min(
      1,
      Math.max(0, (thirdCardProgress - animationStartThreshold) / (animationEndThreshold - animationStartThreshold))
    );
    const targetRevealedCount = Math.floor(mappedProgress * totalBoxes);
    setRevealedBoxCount(prevCount => {
      const newCountByTens = Math.floor(targetRevealedCount / 10) * 10;
      if (newCountByTens > prevCount) {
        return Math.min(newCountByTens, totalBoxes);
      } else if (newCountByTens < prevCount) {
        return Math.max(0, Math.ceil(targetRevealedCount / 10) * 10);
      }
      return prevCount;
    });
  }, [cardScrollProgress, totalBoxes]);

  const sectionRef = useRef(null);
  const ani2Ref = useRef(null);
  const iconRef = useRef(null); // 9칸 그리드 전체를 감싸는 ref
  const svgLogoRef = useRef(null); // 중앙에 고정될 SVG 로고 ref
  const imgRef = useRef(null);
  const displayRef = useRef(null);
  const pathRef = useRef(null);
  const projectRef = useRef(null);
  const lastRef = useRef(null);
  const boxOpacityRef = useRef(null);
  const boxScaleRef = useRef(null);
  const boxScaleRefs = useRef([]);
  const boxOpacityRefs = useRef([]);
  const boxColorRefs = useRef([]);
  // const bottomBarsRef = useRef([]);
  const lastAni2Ref = useRef();
  const textAnimationContainerRef = useRef(null);
  const containerRef = useRef(null);



  const individualCarouselItemRefs = useRef(
    Array(9).fill(null).map(() => Array(carouselItems.length).fill(null))
  );

  const heightRanges = [
    ['0%', '76%', '98.7%', '90%', '100%'],
    ['0%', '55%', '98.5%', '92%', '100%'],
    ['0%', '88%', '97.8%', '90%', '100%'],
    ['0%', '66%', '99%', '90.6%', '100%'],
    ['0%', '40%', '97%', '93%', '100%']
  ];

  const { scrollYProgress: barAnimationProgress } = useScroll({
    target: lastAni2Ref,
    offset: ["start end", "end end"] // 요소가 화면에 보이기 시작할 때부터 사라질 때까지
  });

  const addIndividualCarouselRef = (el, gridIndex, itemIndex) => {
    if (el && individualCarouselItemRefs.current[gridIndex] && individualCarouselItemRefs.current[gridIndex][itemIndex] !== el) {
      individualCarouselItemRefs.current[gridIndex][itemIndex] = el;
    }
  };

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {

      // grid display none으로 변경
      const divNone = gsap.timeline({
        scrollTrigger: {
          trigger: displayRef.current,
          start: "bottom top-=5000",
          end: "70% top",
          scrub: 1,
          // markers:true
        }
      });
      divNone.to(displayRef.current, {
        backgroundColor: 'black'
      })

      // aniRef div opacity 조절
      const divOpacity = gsap.timeline({
        scrollTrigger: {
          trigger: ani2Ref.current,
          start: "bottom bottom+=4200",
          end: "70% top",
          scrub: 1,
          // markers:true
        }
      });
      divOpacity.to(ani2Ref.current, {
        opacity: 1
      })

      // SVG 로고 애니메이션 (기존 useTransform 대체)
      const svgTl = gsap.timeline({
        scrollTrigger: {
          trigger: ani2Ref.current,
          start: "30% top",
          end: "70% top",
          scrub: 1,
        }
      });
      svgTl.to(svgLogoRef.current, {
        x: '56vw',
        width: '5800vw',
        height: '5800vw',
        ease: 'none'
      });

      // svg 배경 opacity
      const svgOpacityTl = gsap.timeline({
        scrollTrigger: {
          trigger: ani2Ref.current,
          start: "30% top",
          end: "top top",
          scrub: 1,
        }
      });
      svgOpacityTl.to(svgLogoRef.current, {
        opacity: 1
      });

      // 로고 내부 path opacity 조절
      const pathTl = gsap.timeline({
        scrollTrigger: {
          trigger: ani2Ref.current,
          start: "10% top",
          end: "70% top",
          scrub: 1,
        }
      });
      pathTl.to(pathRef.current, {
        opacity: 0,
      });

      // meImg opacity 조절
      const imgOpacity = gsap.timeline({
        scrollTrigger: {
          trigger: ani2Ref.current,
          start: "bottom bottom+=1700",
          end: "70% top",
          scrub: 1,
          // markers:true
        }
      });
      imgOpacity.to(imgRef.current, {
        opacity: 1
      })

      // meImg opacity 다시 0으로
      const imgOpacity2 = gsap.timeline({
        scrollTrigger: {
          trigger: ani2Ref.current,
          start: "70% top",
          end: "bottom bottom-=2500",
          scrub: 1,
          // markers:true
        }
      });
      imgOpacity2.to(imgRef.current, {
        opacity: 0
      })

      // 전체 아이콘 영역(iconRef)의 등장 및 사라짐 애니메이션
      const iconOpacityTl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top bottom",
          end: "10% top",
          scrub: true,
        }
      });
      iconOpacityTl
        .to(iconRef.current, { opacity: 1 }, "0")
        .to(iconRef.current, { opacity: 1 }, "0.3")
        .to(iconRef.current, { opacity: 0 }, "0.31")

      // 8개 칸에 대한 아이콘 캐러셀 애니메이션 타임라인
      const numCarouselItems = carouselItems.length; // 5개 아이템
      const showDuration = 0.5; // 각 아이템이 완전히 보여지는 시간 (투명도 1을 유지하는 시간)
      const fadeDuration = 0.1; // 나타나고 사라지는 시간 (동일하게 0.5초로 유지)
      const totalItemDuration = showDuration + fadeDuration; // 한 아이템의 총 주기 시간

      const gridIndicesForCarousel = [0, 1, 2, 3, 5, 6, 7, 8];

      gridIndicesForCarousel.forEach((gridIndex, offsetIndex) => {
        const currentGridCarouselRefs = individualCarouselItemRefs.current[gridIndex];

        const allRefsReadyForThisGrid = currentGridCarouselRefs && currentGridCarouselRefs.every(ref => ref !== null);

        if (allRefsReadyForThisGrid) {
          const carouselTl = gsap.timeline({
            repeat: -1, // 무한 반복
            delay: offsetIndex * (totalItemDuration / gridIndicesForCarousel.length), // 각 그리드 칸의 시작 시간을 다르게 설정하여 순차적으로 보이게 함
            paused: true, // 초기에는 정지
          });

          // 모든 캐러셀 아이템의 초기 상태를 투명하게 설정
          gsap.set(currentGridCarouselRefs, { opacity: 0 });
          // 첫 번째 캐러셀 아이템은 미리 보이도록 설정 (애니메이션 시작 전)
          gsap.set(currentGridCarouselRefs[0], { opacity: 1 });

          for (let i = 0; i < numCarouselItems; i++) {
            const currentItem = currentGridCarouselRefs[i];
            const nextItemIndex = (i + 1) % numCarouselItems;
            const nextItem = currentGridCarouselRefs[nextItemIndex];

            if (currentItem && nextItem) {
              carouselTl
                // 현재 아이템이 0.5초 동안 보이고 (opacity: 1 유지), 그 후 0.1초 동안 사라짐
                .to(currentItem, { opacity: 1, duration: showDuration, ease: "none" }) // 0.5초 동안 투명도 1 유지
                .to(currentItem, { opacity: 0, duration: fadeDuration, ease: "power2.in" }, `+=${0}`) // 0.1초 동안 사라짐 (이전 애니메이션 끝나는 시점부터)

                // 다음 아이템이 0.5초 동안 나타남 (현재 아이템이 사라지는 동안 나타나기 시작)
                .to(nextItem, { opacity: 1, duration: fadeDuration, ease: "power2.out" }, `-=${fadeDuration}`); // 현재 아이템 사라지기 시작할 때 다음 아이템 나타나기 시작
            }
          }

          // 스크롤 트리거 로직은 그대로 유지
          ScrollTrigger.create({
            trigger: ani2Ref.current,
            start: "bottom bottom+=3200",
            end: "bottom bottom",
            // markers:true,
            onEnter: () => carouselTl.play(), // ani2Ref가 시작 지점을 지날 때 play
            onLeaveBack: () => carouselTl.pause(0), // 다시 위로 스크롤하여 start 지점을 벗어날 때 정지 (처음으로)
            onLeave: () => carouselTl.pause(), // 아래로 스크롤하여 end 지점을 벗어날 때 정지
            onEnterBack: () => carouselTl.play(), // 다시 위로 스크롤하여 end 지점으로 돌아올 때 play
          });
        } else {
          // console.warn(`Refs for grid index ${gridIndex} are not yet ready.`);
        }
      });
      //마지막 opacity, scale 애니메이션
      const lastSectionTimeline = gsap.timeline({
        scrollTrigger: {
          trigger: lastRef.current,
          start: "top bottom-=6000",
          end: "bottom bottom",
          scrub: 3,
          // markers:true,
          onLeaveBack: () => {
            gsap.set(boxScaleRefs.current, { height: '0%' });
            gsap.set(boxOpacityRefs.current, { opacity: 0 });
          },
          invalidateOnRefresh: true,
        }
      });

      const totalBoxesForLastAnim = 10;
      const staggerOffset = 0.2;

      for (let i = totalBoxesForLastAnim - 1; i >= 0; i--) {
        const scaleBox = boxScaleRefs.current[i];
        const opacityBox = boxOpacityRefs.current[i];
        const startTime = (totalBoxesForLastAnim - 1 - i) * staggerOffset;

        if (scaleBox) {
          lastSectionTimeline.to(scaleBox, {
            height: '100%',
            duration: 0.5,
            ease: "none"
          }, startTime);
        }

        if (opacityBox) {
          lastSectionTimeline.to(opacityBox, {
            opacity: 0.1,
            duration: 0.5,
            ease: "none"
          }, startTime);
        }
      }

      lastSectionTimeline.to(boxScaleRefs.current, {
        backgroundColor: 'black',
        duration: 0.1, // 0.1초 동안 부드럽게 색상이 변경
        ease: 'none',
        // stagger 객체로 순차 애니메이션을 설정
        stagger: {
          each: 0.05,   // 각 박스의 색상이 0.05초 간격으로 변경
          from: "end"   // 배열의 끝(가장 아래 박스)부터 시작
        }
      }, "<");

      // 5개 div의 높이를 조절하는 새로운 GSAP 타임라인
      // const bottomBarsTimeline = gsap.timeline({
      //   scrollTrigger: {
      //     trigger: lastAni2Ref.current,
      //     start: "top+=1000 top",
      //     end: "bottom bottom",
      //     // 스크롤에 따라 애니메이션을 부드럽게 연결
      //     scrub: true,
      //     // markers: true, // 디버깅 시 위치 확인용
      //   }
      // });

      // const durations = [1.5, 1.1, 1.4, 1.2, 1.3];

      // // 2. 5개의 div 각각에 정의된 duration을 적용
      // bottomBarsRef.current.forEach((bar, index) => {
      //   if (bar) {
      //     bottomBarsTimeline.to(bar, {
      //       height: '100%',
      //       // index에 해당하는 duration 값을 할당
      //       duration: durations[index],
      //       ease: "none"
      //     }, 0); // 0을 지정하여 모든 애니메이션이 타임라인의 시작점에서 동시에 시작되도록 함
      //   }
      // });

    }, sectionRef);




    return () => ctx.revert();
  }, [carouselItems.length]);


  // 가로 스크롤 (기존 로직 유지)
  const wrapperRef = useRef(null);
  const innerRef = useRef(null);
  useEffect(() => {
    const wrapper = wrapperRef.current;
    const inner = innerRef.current;
    if (!wrapper || !inner) return;

    // inner 요소가 실제로 차지하는 가로 스크롤 너비
    const scrollWidth = inner.scrollWidth;
    // 현재 보이는 화면의 너비
    const viewportWidth = window.innerWidth;

    // 실제로 가로로 움직여야 하는 총 거리
    const horizontalScrollDistance = scrollWidth - viewportWidth - 500;

    const tl = gsap.to(inner, {
      x: () => -horizontalScrollDistance, // x축 이동 거리도 동적으로 설정
      ease: "none",
      scrollTrigger: {
        trigger: wrapper,
        start: "top top",
        // end 값을 가로 스크롤 거리만큼 동적으로 설정
        end: () => `+=${horizontalScrollDistance}`,
        scrub: true,
        pin: true,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        // markers: true
      },
    });
    return () => {
      tl.kill();
    };
  }, []);

  // developer ani (기존 로직 유지)
  const developerRef = useRef(null);
  useEffect(() => {
    if (!developerRef.current) return;
    const letters = developerRef.current.querySelectorAll(".developer-letter");
    gsap.fromTo(
      letters,
      { y: "0%", opacity: 1 },
      {
        y: "-120%",
        opacity: 0,
        stagger: 0.1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: developerRef.current,
          start: "top top",
          end: "bottom top-=500",
          scrub: true,
          // markers:true
        },
      }
    );
  }, []);

  const developer2Ref = useRef(null);
  useEffect(() => {
    if (!developerRef.current) return;
    const letters = developer2Ref.current.querySelectorAll(".developer-letter2");
    gsap.fromTo(
      letters,
      { y: "120%", opacity: 0 },
      {
        y: "0%",
        opacity: 1,
        stagger: 0.1,
        ease: "power1.out",
        scrollTrigger: {
          trigger: developer2Ref.current,
          start: "top top",
          end: "bottom top-=500",
          scrub: true,
          // markers:true
        },
      }
    );
  }, []);

  // hover 시 동영상 재생
  // const handleMouseEnter = (e) => {
  //   const video = e.currentTarget.querySelector('video');
  //   if (video) {
  //     video.play();
  //   }
  // };

  // const handleMouseLeave = (e) => {
  //   const video = e.currentTarget.querySelector('video');
  //   if (video) {
  //     video.pause();
  //   }
  // };

  // 이미지, 비디오 보이게 하는 애니메이션
  // const mediaRefs = useRef([]);

  // useEffect(() => {
  //   mediaRefs.current.forEach((el, index) => {
  //     if (!el) return;

  //     // console.log(projects[index].src) 로 확인 후 아래 조건 수정
  //     const isVideo = typeof projects[index].src === 'string' && projects[index].src.includes('.mp4');

  //     gsap.set(el, { width: 0, height: 0 });

  //     // 개선된 animateProps
  //     let animateProps = {
  //       width: isVideo ? '45%' : '45%',
  //       height: isVideo ? '45%' : '45%',
  //     };

  //     gsap.to(el, {
  //       ...animateProps,
  //       duration: 1,
  //       ease: 'power2.out',
  //       scrollTrigger: {
  //         trigger: el,
  //         start: 'top bottom-=2800', // 더 안정적인 trigger 조건
  //         end: 'bottom bottom-=2800',
  //         toggleActions: 'play none none none',
  //         // markers: true
  //       },
  //     });
  //   });
  // }, [projects]);

  useLayoutEffect(() => {
    if (!textAnimationContainerRef.current) {
      return;
    }
    const ctx = gsap.context(() => {
      const masterTl = gsap.timeline({ repeat: -1 });

      // 각 라인(문장)을 순회
      TEXT_LINES.forEach((line, index) => {
        // 현재 라인 컨테이너 안의 모든 .anim-char 클래스를 가진 요소를 배열로 가져옴
        const chars = gsap.utils.toArray(`.anim-char`, textAnimationContainerRef.current.querySelector(`[data-line-index="${index}"]`));

        if (chars.length === 0) return;

        const lineTl = gsap.timeline();
        lineTl
          .fromTo(chars,
            { y: '110%' },
            {
              y: '0%',
              duration: 0.7,
              stagger: 0.04,
              ease: 'power2.out'
            }
          )
          .to(chars,
            {
              delay: 2,
              y: '-110%',
              duration: 0.7,
              stagger: 0.04,
              ease: 'power2.in'
            }
          );

        masterTl.add(lineTl);
      });
    }, textAnimationContainerRef);

    return () => ctx.revert();
  }, []);

  const textElements = React.useMemo(() => {
    const texts = [
      ...Array(6).fill('THANK U'),
    ];
    return texts.map((text, index) => ({
      id: index,
      text: text,
      // 화면 내부에 무작위로 위치시킵니다 (vw, vh 사용).
      style: {
        top: `${Math.random() * 90}vh`,
        left: `${Math.random() * 90}vw`,
      }
    }));
  }, []);

  // 2. GSAP 애니메이션 설정
  useLayoutEffect(() => {
    if (!containerRef.current) return;

    // GSAP 컨텍스트를 사용하여 애니메이션을 안전하게 관리하고 정리
    const ctx = gsap.context(() => {
      // 클래스 이름으로 모든 텍스트 요소를 선택
      const texts = gsap.utils.toArray('.thank-you-text', containerRef.current);
      // 순서를 무작위로 섞음
      const shuffledTexts = gsap.utils.shuffle(texts);

      // 무한 반복하는 마스터 타임라인을 생성
      const masterTl = gsap.timeline({ repeat: -1, delay: 1 });

      const groupSize = 5; // 한 번에 애니메이션 할 그룹 크기
      const numGroups = Math.ceil(shuffledTexts.length / groupSize);
      const animationDuration = 1; // 한 그룹의 애니메이션 시간 (나타나는 데 1.5초, 사라지는 데 1.5초)
      const overlap = 1; // 다음 그룹 애니메이션이 시작될 때까지의 시간 간격

      // 섞인 텍스트를 5개 그룹으로 나누어 애니메이션을 적용
      for (let i = 0; i < numGroups; i++) {
        const group = shuffledTexts.slice(i * groupSize, (i + 1) * groupSize);

        if (group.length > 0) {
          // to() 애니메이션에 yoyo와 repeat를 사용하여 opacity를 0 -> 1 -> 0 으로 만듦
          masterTl.to(group, {
            opacity: 1,
            duration: animationDuration / 2,
            stagger: 0.15, // 그룹 내 텍스트들이 순차적으로 나타나게 함
            ease: 'power1.inOut',
            yoyo: true,  // 애니메이션을 반대로 재생 (1 -> 0)
            repeat: 1,   // 1번 반복 (나타났다 사라짐)
          }, i * overlap); // 각 그룹의 애니메이션 시작 시간을 조절하여 겹치게 만듦
        }
      }
    }, containerRef);

    // 컴포넌트가 언마운트될 때 GSAP 애니메이션과 ScrollTrigger를 모두 정리
    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className="relative block overflow-x-clip">
      <div className="relative flex flex-wrap w-full items-center pointer-events-none text-[16px]">
        {/* 1번 애니메이션 */}
        <div ref={displayRef} className="fixed flex top-0 left-0 w-full h-screen flex-wrap"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0)' }}
        >
          {boxes.map((boxIndex) => (
            <motion.div
              key={boxIndex}
              className="w-[5vw] h-[10vh] flex-grow-1 bg-[#000000]" //bg-[#302e2e]
              initial={{ opacity: 0 }}
              animate={{ opacity: fixedRevealOrder.indexOf(boxIndex) < revealedBoxCount ? 1 : 0 }}
            />
          ))}
        </div>

        {/* 2번 애니메이션 */}
        <div ref={ani2Ref} className='relative block w-full h-[400vh] '
          style={{ opacity: 0 }}>
          {/* mixBlendMode: 'difference', */}
          <div className='fixed flex flex-wrap top-0 left-0 w-screen h-screen items-center justify-center overflow-x-clip'>

            <div className='absolute flex w-screen h-full items-center justify-center'>
              <div ref={imgRef} className='absolute top-10 w-screen h-[150vh]'
                style={{ opacity: 0, willChange: 'clip-path, opacity' }}
              >
                <img src={me} alt="me" className='w-screen h-screen object-cover' />
              </div>
              {/* 로고 박스 (애니메이션이 적용된 중앙 SVG) */}
              <div className='absolute flex w-screen h-full items-center justify-center'>
                <svg
                  ref={svgLogoRef}
                  id="b"
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  viewBox="0 0 886.2 1106.5"
                  className="absolute"
                  style={{
                    opacity: 0.3,
                    height: '18vw',
                    width: '18vw',
                    overflow: 'hidden',
                    fill: '#000000',
                    flexShrink: 1,
                  }}
                >
                  <path
                    ref={pathRef}
                    id="about-logo_grey"
                    data-name="about-logo grey"
                    d="M87.1 193.2h712v720h-712z"
                    style={{ fill: 'rgb(184, 184, 184)', strokeWidth: 0, opacity: 1 }}
                  />
                  <path d="M473 579.7c0 5.7 4.6 9.3 11.9 9.3 11.6 0 18.7-7.2 18.8-18.2v-1.6h-16.2c-9.3 0-14.6 3.8-14.6 10.5Z" className="cls-1" />
                  <path d="M-1-.3v1106.7h887.3V-.3H-1Zm276.1 605.2c-22.5 0-37.7-10.5-38.6-27.8h21c.8 7.1 6.9 11.9 17.7 11.9s14.9-3 14.9-8.6-5.5-7.1-18.5-8.8c-18.8-2.2-33.5-6.4-33.5-23.1s14-26.5 34.7-26.4c21.7 0 36.6 9.6 37.7 26.1h-21.2c-.6-6.4-6.8-10.4-15.7-10.4s-14.3 3.1-14.3 8.3 6.9 6.8 18.5 8.2c18.5 1.9 33.9 6.1 33.9 24.3s-15.1 26.2-36.7 26.2Zm169.8-.9h-22.1v-45.1c0-12.1-4.4-18.4-14-18.4s-16 7.1-16 19.3v44.1h-22.1v-45.1c0-12.1-4.4-18.4-14.1-18.4s-15.9 7.4-15.9 19.5v44h-22.1v-80.7h19.3l2 10.1c4.9-6.3 11.9-10.8 23.7-11 9.9-.2 19.2 3.5 24.2 13.7 5.7-8.6 15.1-13.7 27.3-13.7s29.8 9.4 29.8 35.3v46.3Zm88.4 0H522c-11.5 0-15.1-5.5-14.9-13.2-5.7 9-13.8 14.1-26.4 14.1s-30-8.3-30-23.7 12.9-26.9 37.1-26.9h16v-3.9c0-7.2-5.2-11.9-14.4-11.9s-14.4 3.9-15.4 9.9h-21.4c1.6-15.7 16-26.1 37.4-26.1s35.7 10.1 35.7 29.4v28.6c0 4.2 1.7 5 5.2 5h2.5V604Zm52.8-60.6h-8.8c-13.2 0-18.2 8.8-18.2 21V604H537v-80.7h20.1l2 12.1c4.4-7.2 10.7-12.1 23.2-12.1h3.8v20.1Zm58.3 60.6h-18.1c-15.4 0-23.1-7.7-23.1-23.1V542h-13.3v-18.7h13.3v-22.6h22.1v22.6h18.5V542h-18.5v35.3c0 5.7 2.2 8 8 8h11V604Z" className="cls-1" />
                </svg>
              </div>
            </div>

            {/* 아이콘들 영역: 9개의 그리드 칸 */}
            <div ref={iconRef} className='relative top-0 py-[10vh] px-[5.2vw] w-screen h-screen grid grid-cols-3 grid-rows-3 items-center justify-center opacity-0'
              style={{ willChange: 'opacity' }}
            >
              {Array.from({ length: 9 }).map((_, gridIndex) => (
                <div
                  key={gridIndex}
                  className={`relative flex w-full h-full items-center justify-center`}
                >
                  {/* 중앙(index 4)은 빈칸으로 두거나, 필요시 특정 placeholder를 넣을 수 있음 */}
                  {gridIndex === 4 ? (
                    <div className="w-full h-full"></div>
                  ) : (
                    // 나머지 8개 칸에서는 carouselItems를 모두 absolute로 겹쳐서 렌더링
                    carouselItems.map((item, itemIndex) => {
                      const itemClasses = `absolute`;
                      return item.type === 'image' ? (
                        <img
                          key={`${gridIndex}-${itemIndex}-img`}
                          src={item.src}
                          alt={item.alt}
                          className={`${itemClasses} w-20 h-20 object-contain`}
                          // Ref를 addIndividualCarouselRef로 전달
                          ref={el => addIndividualCarouselRef(el, gridIndex, itemIndex)}
                          style={{ opacity: itemIndex === 0 ? 1 : 0 }} // 초기 첫 아이템만 보이게
                        />
                      ) : (
                        <div
                          key={`${gridIndex}-${itemIndex}-text`}
                          className={`${itemClasses} flex text-center items-center justify-center text-white text-4xl font-bold`}
                          // Ref를 addIndividualCarouselRef로 전달
                          ref={el => addIndividualCarouselRef(el, gridIndex, itemIndex)}
                          style={{ opacity: itemIndex === 0 ? 1 : 0 }} // 초기 첫 아이템만 보이게
                        >
                          <span>{item.content}</span>
                        </div>
                      );
                    })
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className='h-[1487.5px]'></div>
        {/* <div className='h-[1120px]'></div>
        <div className='h-[928.2px]'></div> */}
      </div>
      <div className='relative w-full -mt-[100vh] z-[999] font-aeonik font-normal' style={{ mixBlendMode: 'difference' }}>
        <span className="relative block text-[5.2083333333vw] text-[#b1b1b1] leading-[1em] px-[3.125vw] text-justify [text-align-last:justify] [text-indent:46.66667vw]">
          <h1>Hard-Working Dev<br />is a front-end developer crafting modern web interfaces for innovative brands like</h1>
        </span>
      </div>
      {/* 소개 부분 */}
      <div ref={wrapperRef} className='relative w-full z-[999] font-aeonik font-normal' >
        {/* <span className="relative block text-[5.2083333333vw] text-[#b1b1b1] leading-[1em] px-[3.125vw] text-justify [text-align-last:justify] [text-indent:46.66667vw]"
          style={{ mixBlendMode: 'difference' }}>
          <h1>Hard-Working Dev<br />is a front-end developer crafting modern web interfaces for innovative brands like</h1>
        </span> */}
        <div ref={innerRef} className="block z-[999] m-0 absolute overflow-visible box-border w-[7384px] h-screen p-0">
          <div className="block absolute translate-none rotate-0 scale-100 inset-t-0 inset-l-0 m-0 w-[1326px] max-h-[962px] h-[962px] p-0">
            <div className={`relative flex w-fit h-full`}>
              <div className='relative flex flex-col -ml-[30vw] overflow-x-clip max-sm:-ml-[35vw]'>
                <span ref={developerRef} className='text-[80vh] max-sm:text-[50vh]'>
                  <span className="flex items-center text-[#ffffff] flex-shrink-0 h-screen leading-[1.2em] ml-[0.67em] pl-[3.125vw] relative whitespace-nowrap">
                    <span>
                      <span>
                        {"Mini Project".split("").map((char, index) => (
                          <span key={index} className='developer-letter inline-block'>{char}</span>
                        ))}
                      </span>
                    </span>
                  </span>
                </span>
                <span ref={developer2Ref} className='absolute text-[80vh] ml-[34rem] max-sm:text-[50vh] max-sm:ml-[20rem]'>
                  <span className="flex items-center text-[#ffffff] flex-shrink-0 h-screen leading-[1.2em] -ml-[0.067em] pl-[3.125vw] relative whitespace-nowrap">
                    <span>
                      <span>
                        {"Mini Project".split("").map((char, index) => (
                          <span key={index} className='developer-letter2 inline-block'>{char}</span>
                        ))}
                      </span>
                    </span>
                  </span>
                </span>
              </div>
              <div ref={projectRef} className="translate-none rotate-0 scale-100 h-screen z-auto -mr-[20vw] min-w-[2000px] relative w-[300vw]" style={{ mixBlendMode: 'difference' }}>
                {projects.map((item, index) => (
                  <ProjectItem key={index} item={item} />
                ))}
              </div>
            </div>
          </div>

        </div>

      </div>
      {/* 애니메이션 / 마지막 소개 섹션 about-measurements */}
      <div ref={lastRef} className='relative overflow-x-clip z-[9999]'>

        {/* trigger */}
        <div className='absolute top-0 h-screen'></div>

        {/* w-full box */}
        <div className='fixed w-screen h-screen top-0 left-0 pointer-events-none mix-blend-difference'>
          {Array(10).fill(0).map((_, index) => (
            <div key={index} className='relative flex w-full h-[10%] justify-end' style={{ transformOrigin: 'left' }} >
              <div ref={el => boxScaleRefs.current[index] = el} className='absolute w-full bg-[]' style={{ transformOrigin: 'bottom', height: '0%', backgroundColor: '#252525' }}></div>
              <div ref={el => boxOpacityRefs.current[index] = el} className='absolute w-full h-0 top-0' style={{ borderBottom: '1px dashed #b8b8b8', opacity: 0 }}></div>
            </div>
          ))}
        </div>
        <div className='fixed flex w-screen h-screen top-0 left-0 items-end mix-blend-difference pointer-events-none'>
          {heightRanges.map((range, index) => (
            <div key={index} className='relative w-[20%] h-full bottom-0' >
              <div className='absolute w-full left-0 bottom-0 bg-[#b8b8b8]' style={{ opacity: 0, height: '90%' }}></div>
              {/* AnimatedBar에 scrollProgress와 heightRange를 props로 전달 */}
              <AnimatedBar
                scrollProgress={barAnimationProgress}
                heightRange={range}
              />
            </div>
          ))}
        </div>

        <div ref={lastAni2Ref} className='absolute pt-[300vh] z-[99999] isolation mix-blend-difference bg-transparent'>
          <span className="relative block pt-[100vh] text-[5.2083333333vw] left-[3.125vw] leading-[1em] mix-blend-difference text-justify w-[93.75vw]">
            <h2 className='text-[white]'>
              Hard-Working Dev is a front-end developer crafting modern web interfaces for innovative brands like
            </h2>
          </span>
          <div ref={textAnimationContainerRef} className='relative flex w-screen h-screen justify-center items-center mt-[20vh]'>
            <span className='sticky top-[0%] block text-[15.625vw] leading-[12vw] text-center uppercase z-20 text-[#ffffff]'>
              <span className='relative block'>
                {TEXT_LINES.map((line, lineIndex) => (
                  <div
                    key={lineIndex}
                    // GSAP이 각 라인을 쉽게 찾을 수 있도록 data-attribute 추가
                    data-line-index={lineIndex}
                    className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center whitespace-nowrap'
                    aria-hidden={true}
                  >
                    <div
                      key={lineIndex}
                      data-line-index={lineIndex}
                      aria-hidden={true}
                      className='absolute uppercase'
                    ></div>
                    {/* 1. 띄어쓰기 기준으로 단어 분리 */}
                    {line.split(' ').map((word, wordIndex) => (
                      // 2. 각 단어를 block 요소(div)로 감싸 줄바꿈 처리
                      <div key={wordIndex}>
                        {/* 3. 단어를 글자로 분리 */}
                        {word.split('').map((char, charIndex) => (
                          <span key={charIndex} className='inline-block overflow-hidden z-20'>
                            {/* 4. 애니메이션 대상이 될 글자에 공통 클래스(anim-char) 부여 */}
                            <span
                              className={`anim-char inline-block ${char === '@' ? 'text-[12vw] pb-[5vh]' : 'pb-[3vh]'
                                }`}
                            >
                              {char}
                            </span>
                          </span>
                        ))}
                      </div>
                    ))}
                  </div>
                ))}
              </span>
            </span>
            <div ref={containerRef} className="absolute top-0 left-0 w-full h-full pointer-events-none">
              {textElements.map(el => (
                <span
                  key={el.id}
                  className="thank-you-text absolute z-20 text-[20px] mix-blend-difference text-[#ffffff] whitespace-nowrap"
                  // 초기 opacity를 0으로 설정하고, 생성된 위치값을 적용
                  style={{ ...el.style, opacity: 0 }}
                >
                  {el.text}
                </span>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}

export default Imformation;